import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { NAVIGATION_LABELS } from '../../../helpers/constants'
import NavigationLabel from '../../NavigationLabel/NavigationLabel'

const CommunicationLink = ({ withUpsellingRedirect }) => {
  const { t } = useTranslation(['navbar'])

  return (
    <div className="hover-menu-item">
      <NavLink
        className={({ isActive }) =>
          isActive ? 'navmgr-item__link--active' : 'hover-menu-item__link'
        }
        to={withUpsellingRedirect ? '/dashboard/upselling/communicate' : '/dashboard/announcements'}
        end
      >
        <span>
          {t('navbar:upsellingLinks.announcements')}
          <NavigationLabel type={NAVIGATION_LABELS.NEW} locked={Boolean(withUpsellingRedirect)} />
        </span>
      </NavLink>
    </div>
  )
}

CommunicationLink.propTypes = {
  withUpsellingRedirect: PropTypes.bool,
}

export default CommunicationLink
